import { colors, spacing } from "../theme";

export default function EnterpriseTopBar({
  title = "ShiftBridge Enterprise",
  subtitle,
  right,
}) {
  return (
    <header
      style={{
        background: colors.white,
        borderBottom: `1px solid ${colors.slate200}`,
        padding: spacing.lg,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: spacing.md,
        flexWrap: "wrap",
      }}
    >
      <div>
        <div
          style={{
            fontSize: 18,
            fontWeight: 950,
            color: colors.slate900,
          }}
        >
          {title}
        </div>

        {subtitle ? (
          <div
            style={{
              marginTop: 4,
              fontSize: 12,
              fontWeight: 700,
              color: colors.slate500,
            }}
          >
            {subtitle}
          </div>
        ) : null}
      </div>

      {right || null}
    </header>
  );
}